import { takeLatest, fork, put, all, call, takeEvery } from 'redux-saga/effects';
import { REGISTER_TRIAL_USER, GET_NEW_TRIAL_USER, SEND_REGISTER_TRIAL_USER_EMAIL, UPDATE_TRIAL_USER, DELETE_TRIAL_USER } from './actionTypes';
import {
    registerTrialUserSuccessful,
    registerTrialUserFailed,
    setMessage,
    clearMessage, getTrialUserSuccessful, getTrialUserFailed, updateTrialUserSuccessful, 
    deleteTrialUserSuccessful
} from './actions';

import { getTrialUser as getTrialUserAction } from './actions';

import {
  putRegisterTrialUser,
  getRegisterTrialUser,
  sendRegisterTrialUserEmail,
  updateRegisterTrialUser,
  deleteRegisterTrialUser,
} from "../../helpers/auth_helper";

function* registerTrialUser({ payload: { user } }) {
    try {
        console.log("Zip Code", user.userZipcode)
        const response = yield call(putRegisterTrialUser, {
            firstName: user.userFirstName,
            lastName: user.userLastName,
            phoneNumber: user.userPhone,
            email: user.userEmail,
            country: user.userCountry,
            province: user.userProvince,
            zip: user.userZipcode,
            city: user.userCity,
            address: user.userAddress,
            company: user.companyName,
            comments: user.userComments,
        });
        yield put(registerTrialUserSuccessful(response));
    } catch (error) {
        yield put(registerTrialUserFailed(error));
    }
}

function* getTrialUser() {
    try {
        console.log("about to call");
        const response = yield call(getRegisterTrialUser);
        yield put(getTrialUserSuccessful(response));
    } catch (error) {
        yield put(getTrialUserFailed(error));
    }
}

function* updateTrialUser({ payload: { user } }) {
    console.log("Saga, updateTrialUser = ", user);
    try {
        const dataArray = {
            key: user.key,
            comments: user.comments
        }
        const response = yield call(updateRegisterTrialUser, {
            data: [dataArray]
            // id: user.id,
            // key: user.key,
            // comments: user.comments
            // comments: user.commentField,
            // registrationtype: user.regType.value,
            // maxacounts: user.maxacounts,
            // maxusers: user.maxusers,
            // lowestscanfreq: user.lowestscanfreq,
            // maxdiscount: user.maxdiscount,
            // expirationdt: user.expirationdt,
            // sent: false
        });
        yield put(updateTrialUserSuccessful({status: 200, msg: response}));
        //Added the following to update the redux store, after update is successful
        yield put(getTrialUserAction());
    } catch (error) {
        yield put(updateTrialUserSuccessful({status: 500, msg: error}));
    }
}

function* deleteTrialUser({ payload: { user } }) {
  console.log("Saga Delete Trial User = ", user);
  try {
    const response = yield call(deleteRegisterTrialUser, {
        params: {key: user.key,}      
    });
    yield put(deleteTrialUserSuccessful({ status: 200, msg: response }));
    //Added the following to update the redux store, after delete is successful
    yield put(getTrialUserAction());
  } catch (error) {
    yield put(deleteTrialUserSuccessful({ status: 500, msg: error }));
  }
}


function* setRegisterTrialUserEmail({ payload: { user } }) {
    try {
        console.log('--== setRegisterTrialUserEmail ', user);
        const response = yield call(sendRegisterTrialUserEmail, { id: user.id })
    } catch (error) {
        yield put(sendRegisterTrialUserEmail(error));
    }
}

export function* watchRegisterTrialUser() {
    yield takeLatest(REGISTER_TRIAL_USER, registerTrialUser);
    yield takeLatest(GET_NEW_TRIAL_USER, getTrialUser);
    yield takeLatest(SEND_REGISTER_TRIAL_USER_EMAIL, setRegisterTrialUserEmail);
    yield takeLatest(UPDATE_TRIAL_USER, updateTrialUser);
    yield takeLatest(DELETE_TRIAL_USER, deleteTrialUser);
}

function* registerTrialUserSaga() {
    yield all([fork(watchRegisterTrialUser)]);
}

export default registerTrialUserSaga;